var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alpha-water"},_vm._l((_vm.num),function(i){return _c('div',{key:i,staticClass:"alpha-water-mark"},[_vm._v(_vm._s(_vm.account))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }